"use client";

import * as React from "react";
import { Sun, MoonStarIcon, Check } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";
import { CustomTooltip } from "./tooltip";
import { Button } from "./button";
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger
} from "./dropdown-menu";

export function ModeToggle() {
   const translate = useTranslations("Components.ModeToggle");
   const { setTheme, theme } = useTheme();
   return (
      <DropdownMenu>
         <CustomTooltip text={translate(theme || "system")} delayDuration={1000}>
            <DropdownMenuTrigger asChild>
               <Button
                  variant="ghost"
                  size="icon"
                  className="relative rounded-full hover:bg-gray-200 dark:hover:bg-gray-700"
               >
                  <Sun className="h-[1.2rem] w-[1.2rem] transition-all dark:absolute dark:opacity-0" />
                  <MoonStarIcon className="absolute h-[1.2rem] w-[1.2rem] opacity-0 transition-all dark:opacity-100" />
                  <span className="sr-only">{translate("toggleTheme")}</span>
               </Button>
            </DropdownMenuTrigger>
         </CustomTooltip>
         <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => setTheme("light")}>
               {translate("lightMode")}
               {theme === "light" && <Check className="inline-block w-4 h-4 ml-1" />}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setTheme("dark")}>
               {translate("darkMode")}
               {theme === "dark" && <Check className="inline-block w-4 h-4 ml-1" />}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setTheme("system")}>
               {translate("systemMode")}
               {theme === "system" && <Check className="inline-block w-4 h-4 ml-1" />}
            </DropdownMenuItem>
         </DropdownMenuContent>
      </DropdownMenu>
   );
}
